'use client'
import { useBreakpointValue } from '@chakra-ui/react'
import React from 'react'
import Desktop from './responsive/desktop'
import Mobile from './responsive/mobile'
import { IProps } from './_types'

const Points = ({ isOpen, onClose, isModal }: IProps) => {
  const isDesktop = useBreakpointValue(
    { base: false, lg: true },
    { ssr: false }
  )

  return isDesktop ? (
    <Desktop isOpen={isOpen} onClose={onClose} isModal={isModal} />
  ) : (
    <Mobile isOpen={isOpen} onClose={onClose} />
  )
}

export default Points
